import { render, staticRenderFns } from "./couponRule.vue?vue&type=template&id=31b6012c&scoped=true"
import script from "./couponRule.vue?vue&type=script&lang=js"
export * from "./couponRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6012c",
  null
  
)

export default component.exports